/** Stable selectors for checkout site survey scheduling (Home Review task). */
const CHECKOUT_SITE_SURVEY_TEST_IDS = {
  slotList: undefined,
  slotsRetry: "api-slots-retry",
  noSlots: undefined,
  showUnavailableModal: "show-unavailable-modal",
  scheduledCard: undefined,
  rescheduleButton: undefined,
  cancelButton: "api-site-survey-cancel",
  cancelModal: "site-survey-cancel-appointment-modal",
  cancellationReasonSelect: "cancellation-reason-select",
  cancelLoadingOverlay: "loading-overlay",
  confirmRescheduleModal: "checkout-confirm-reschedule-appointment-modal",
  confirmRescheduleButton: "confirm-reschedule-appointment",
  scheduleErrorModal: "checkout-error-appointment-modal",
  rescheduleErrorModal: "checkout-error-appointment-modal",
  cancelErrorModal: "checkout-error-appointment-modal",
  appointmentLoadErrorModal: "checkout-appointment-load-error-modal",
} as const;

/** Stable selectors for CAP Post final design home review scheduling. */
const POST_CAP_HOME_CHECK_TEST_IDS = {
  slotList: "post-cap-home-check-slot-list",
  slotsRetry: "post-cap-home-check-slots-retry",
  noSlots: "post-cap-home-check-no-slots",
  showUnavailableModal: undefined,
  scheduledCard: "post-cap-home-check-scheduled-card",
  rescheduleButton: "post-cap-home-check-reschedule",
  cancelButton: "post-cap-home-check-cancel",
  cancelModal: "post-cap-home-check-cancel-appointment-modal",
  cancellationReasonSelect: "post-cap-home-check-cancellation-reason-select",
  cancelLoadingOverlay: "post-cap-home-check-cancel-loading",
  confirmRescheduleModal: "post-cap-home-check-confirm-reschedule-modal",
  confirmRescheduleButton: "post-cap-home-check-confirm-reschedule",
  scheduleErrorModal: "post-cap-home-check-schedule-error-modal",
  rescheduleErrorModal: "post-cap-home-check-reschedule-error-modal",
  cancelErrorModal: "post-cap-home-check-cancel-error-modal",
  loadingSkeleton: "post-cap-home-check-loading",
  rescheduleLoadingSkeleton: "post-cap-home-check-reschedule-loading",
  schedulerRoot: "post-cap-home-check-scheduler",
  scheduleSubmit: "post-cap-home-check-schedule-submit",
  signAgreementToSchedule: "post-cap-home-check-sign-agreement-to-schedule",
} as const;

/** Stable selectors for CAP install scheduling. */
const POST_CAP_INSTALL_TEST_IDS = {
  slotList: "post-cap-install-slot-list",
  slotsRetry: "post-cap-install-slots-retry",
  noSlots: "post-cap-install-no-slots",
  showUnavailableModal: undefined,
  scheduledCard: "post-cap-install-scheduled-card",
  rescheduleButton: "post-cap-install-reschedule",
  cancelButton: "post-cap-install-cancel",
  cancelModal: "post-cap-install-cancel-appointment-modal",
  cancellationReasonSelect: "post-cap-install-cancellation-reason-select",
  cancelLoadingOverlay: "post-cap-install-cancel-loading",
  confirmRescheduleModal: "post-cap-install-confirm-reschedule-modal",
  confirmRescheduleButton: "post-cap-install-confirm-reschedule",
  scheduleErrorModal: "post-cap-install-schedule-error-modal",
  rescheduleErrorModal: "post-cap-install-reschedule-error-modal",
  cancelErrorModal: "post-cap-install-cancel-error-modal",
  loadingSkeleton: "post-cap-install-loading",
  rescheduleLoadingSkeleton: "post-cap-install-reschedule-loading",
  schedulerRoot: "post-cap-install-scheduler",
  scheduleSubmit: "post-cap-install-schedule-submit",
  signAgreementToSchedule: "post-cap-install-sign-agreement-to-schedule",
  confirmationRefreshButton: "post-cap-install-confirmation-refresh",
  loadSlots: "post-cap-install-load-slots",
  cancelledWarning: "post-cap-install-cancelled-warning",
} as const;

type CapAppointmentSchedulerTestIds = {
  slotList: string | undefined;
  slotsRetry: string;
  noSlots: string | undefined;
  showUnavailableModal: string | undefined;
  scheduledCard: string;
  rescheduleButton: string;
  cancelButton: string;
  cancelModal: string;
  cancellationReasonSelect: string;
  cancelLoadingOverlay: string;
  confirmRescheduleModal: string;
  confirmRescheduleButton: string;
  scheduleErrorModal: string;
  rescheduleErrorModal: string;
  cancelErrorModal: string;
  loadingSkeleton: string;
  rescheduleLoadingSkeleton: string;
  schedulerRoot: string;
  scheduleSubmit: string;
  signAgreementToSchedule: string;
  confirmationRefreshButton?: string;
  loadSlots?: string;
};

export {
  CHECKOUT_SITE_SURVEY_TEST_IDS,
  POST_CAP_HOME_CHECK_TEST_IDS,
  POST_CAP_INSTALL_TEST_IDS,
};
export type { CapAppointmentSchedulerTestIds };
